import { defineStore } from 'pinia'
import { userParameterService } from '@/services/userParameter.service'
import type { LoaderType } from '@/types/types'
import { computed, reactive } from 'vue'
import { toast, i18N } from '@/common/util'

export const useUserParameterStore = defineStore('userParameter', () => {
  /**
   * States
   */
  const status = reactive<Record<string, LoaderType>>({
    create: 'initial',
    update: 'initial',
    delete: 'initial',
    getById: 'initial'
  })

  const loading = computed(() => Object.values(status).some(el => el === 'loading'))

  /**
   * Actions
   */
  const create = async (objData: any) => {
    status.create = 'loading'

    try {
      const { data } = await userParameterService.create(objData)

      status.create = 'success'
      return data
    } catch (error) {
      console.error(error)
      status.create = 'error'
    }
  }

  const update = async (objData: any) => {
    status.update = 'loading'

    try {
      const { data } = await userParameterService.update(objData)

      status.update = 'success'
      return data
    } catch (error) {
      console.error(error)
      status.update = 'error'
    }
  }

  const remove = async (id: string) => {
    status.delete = 'loading'

    try {
      const { success } = await userParameterService.delete(id)

      if (success) toast.success({ message: i18N('toasts.removeSuccess') })

      status.delete = 'success'
      return success
    } catch (error) {
      console.error(error)
      status.delete = 'error'
    }
  }

  const getUserParameter = async () => {
    status.getById = 'loading'

    try {
      const { data } = await userParameterService.getUserParameter()

      status.getById = 'success'
      return data
    } catch (error) {
      console.error(error)
      status.getById = 'error'
    }
  }

  return {
    status,
    loading,
    create,
    update,
    remove,
    getUserParameter
  }
})